import { useEffect } from 'react';

/* global window */
const useConfigureSDPEnv = _ref => {
  let {
    env = 'prod'
  } = _ref;
  const dsEnv = ['qa', 'nonprod'].includes(env) ? 'qa' : '';
  useEffect(() => {
    // Add url query param for Accelerate QA environment, when applicable, otherwise remove for VDP->VDP transition
    if (dsEnv && window?.history?.replaceState) {
      const searchParams = new URLSearchParams(window.location.search);
      if (!searchParams.has('dsEnv')) {
        searchParams.set('dsEnv', dsEnv);
        // eslint-disable-next-line no-console
        console.log('Configuring Accelerate SDP for %s environment', dsEnv);
        window.history.replaceState(window.history.state, '', window.location.pathname + '?' + searchParams.toString());
      }
    }
  }, [dsEnv]);
  return null;
};
export { useConfigureSDPEnv as default };
